import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getQuickActionsCardWidgetStyles = props => {
  return StyleSheet.create({
    innerContainer: {
      display: 'flex',
      justifyContent: (props === null || props === void 0 ? void 0 : props.heading) ? 'space-between' : 'flex-end',
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: tokens.spacing.SPACING_12
    },
    chipContainer: {
      width: '100%',
      flexDirection: 'row',
      alignContent: 'space-between',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      marginTop: tokens.spacing.SPACING_16
    },
    trustMarker: {
      marginTop: tokens.spacing.SPACING_16
    }
  });
};